import React, { createContext, useContext } from 'react';
import apiService, { getBaseURL } from '../services/api';
import useApiData from '../hooks/useApiData';

/**
 * Context for managing site branding (logo, site name)
 * Provides branding data fetched from CMS with fallback defaults
 */
const BrandingContext = createContext();

// Default fallback branding
const DEFAULT_BRANDING = {
  site_name: 'Eye On You',
  logo: null,
};

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within a BrandingProvider');
  }
  return context;
};

export const BrandingProvider = ({ children }) => {
  const {
    data: brandingData,
    loading,
    error,
    refetch,
  } = useApiData(() => apiService.getSiteSettings(), [], {
    fallback: DEFAULT_BRANDING,
    unwrapStrapi: true,
    resourceName: "branding",
    transform: (data) => ({
      siteName: data?.site_name || 'Eye On You',
      logo: data?.logo?.url ? `${getBaseURL()}${data.logo.url}` : null,
    }),
  });

  const value = {
    siteName: brandingData?.siteName || 'Eye On You',
    logo: brandingData?.logo || null,
    loading,
    error,
    refetch,
  };

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
};